import React from "react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { HeroSwiper, HeroSwiperSlide } from "./HeroSection.styled";
import HeroSlide from "./HeroSlide/HeroSlide";
import { heroSlides } from "../../constants/home/heroSlides";

const HeroSection: React.FC = () => {
  return (
    <section>
      <HeroSwiper
        spaceBetween={30}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
      >
        {heroSlides &&
          heroSlides.map((slide, inx) => (
            <HeroSwiperSlide key={inx}>
              <HeroSlide slideData={slide}></HeroSlide>
            </HeroSwiperSlide>
          ))}
      </HeroSwiper>
    </section>
  );
};

export default HeroSection;
